import api from '../utils/api';

// Fetch all timetable records
export const getAllTimetables = async (headers) => {
  try {
    const response = await api.get('/api/timetables', headers);
    return response.data;
  } catch (error) {
    console.error('Error fetching all timetables:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific timetable record by ID
export const getTimetableById = async (id, headers) => {
  try {
    const response = await api.get(`/api/timetables/${id}`, headers);
    console.log("single time table", response.data)
    return response.data;
  } catch (error) {
    console.error('Error fetching timetable by ID:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new timetable record
export const createTimetable = async (timetableData, headers) => {
  try {
    const response = await api.post('/api/timetables', timetableData, headers);
    return response.data;
  } catch (error) {
    console.error('Error creating timetable:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing timetable record
export const updateTimetable = async (id, timetableData, headers) => {
  try {
    const response = await api.put(`/api/timetables/${id}`, timetableData, headers);
    return response.data;
  } catch (error) {
    console.error('Error updating timetable:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a timetable record
export const deleteTimetable = async (id, headers) => {
  try {
    const response = await api.delete(`/api/timetables/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error('Error deleting timetable:', error.response ? error.response.data : error.message);
    throw error;
  }
};
